import { Text, Box, Flex, Loader } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import pluralize from 'pluralize';
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { useCalendars } from 'src/meetings/hooks/useCalendars';
import { CalendarConnectionsModal } from './CalendarConnectionsModal';
import { CalendarAccountIcon } from './CalendarAccountIcon';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export const CalendarAccountsPreview = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('connect') === 'true') {
      open();
      setSearchParams(
        prev => {
          prev.delete('connect');
          return prev;
        },
        { replace: true },
      );
    }
  }, [searchParams, open, setSearchParams]);
  const { connecting, calendars } = useCalendars();
  const numDisconnected = useMemo(() => {
    return calendars.filter(c => c.status === 'DISCONNECTED').length;
  }, [calendars]);

  return (
    <>
      <Flex align="center">
        {calendars.map((calendar, index) => (
          <Box
            key={calendar.id}
            onClick={open}
            bg="white"
            bd="2px solid var(--mantine-color-gray-1)"
            style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: -12,
              zIndex: index,
              cursor: 'pointer',
            }}
          >
            <CalendarAccountIcon platform={calendar.platform} variant="small" />
          </Box>
        ))}

        <Box
          onClick={open}
          bg="white"
          bd="2px solid var(--mantine-color-gray-1)"
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: calendars.length + 1,
          }}
        >
          <IconPlus size={16} color="var(--mantine-color-gray-10)" />
        </Box>

        {connecting && (
          <Loader size={16} ml="xs" variant="dots" color="var(--mantine-color-gray-6)" />
        )}

        {numDisconnected > 0 && (
          <Text size="sm" fw={FONT_WEIGHTS.medium} c="error.6" ml="xs">
            {numDisconnected} {pluralize('calendar', numDisconnected)} disconnected
          </Text>
        )}
      </Flex>

      <CalendarConnectionsModal opened={opened} close={close} />
    </>
  );
};
